import classNames from 'classnames';
import * as React from 'react';
import ReactPlayer from 'react-player/youtube';

import { BlockSectionClassResolver } from '../../BlockSection/BlockSectionClassResolver';
import { VideoPlayerSize } from './VideoPlayerSize.csharp';
import { VideoProps } from './VideoProps.csharp';

export class Video extends React.Component<VideoProps, { isThumbnailVisible: boolean }> {
    constructor(props: VideoProps) {
        super(props);
    }

    render() {
        const { url, width, height, thumbnailImage, playerSize, blockSectionMargin } = this.props.model;

        const video = (
            <ReactPlayer
                url={url}
                controls
                width="100%"
                height="100%"
                playing={!!thumbnailImage}
                playsinline={!!thumbnailImage}
                light={thumbnailImage?.url || false}
            />
        );

        const paddingBottom = height / width;

        return (
            <div className={classNames('Video', `Video--${VideoPlayerSize[playerSize]}`, BlockSectionClassResolver.Resolve(blockSectionMargin))}>
                <figure className="Video__Figure">
                    <div className="Video__FigureContainer" style={{ paddingBottom: paddingBottom * 100 + '%' }}>
                        {video}
                    </div>
                </figure>
            </div>
        );
    }
}
